import React, { memo } from 'react'
import ClipboardCopy from 'transfix-ui/components/Copy'

interface ILabelValueProps extends JSX.ElementChildrenAttribute {
  label: string
  fmcsa?: boolean
  clickToCopy?: boolean
}

export const LabelValue = memo<ILabelValueProps>(
  ({ children: value, clickToCopy, fmcsa, label }) => (
    <div className='pv1'>
      <div className='text-secondary'>{label}:</div>
      {value}
      {clickToCopy && (
        <>
          &nbsp;
          <ClipboardCopy copyText={`${value}`} alignClass='left' useIcon />
        </>
      )}
      {fmcsa && <>&nbsp;(via FMCSA)</>}
    </div>
  )
)
